<template>
  <div class="benefits-item">
    <div v-if="$props.points !== undefined && $props.points !== null" class="benefits-points">
      <p>{{ $props.points }}</p>
      <span>{{ pointsText }}</span>
    </div>
    <div class="benefits-info">
      <div class="benefits-desc">
        <div>
          <p class="benefits-desc-title">{{ $props.title }}</p>
          <p v-if="$props.description" class="benefits-desc-text">{{ $props.description }}</p>
        </div>
        <span v-if="$props.totalPoints >= 0" class="total-points">{{ $props.totalPoints }}</span>
      </div>
      <base-button v-if="$props.points !== undefined && $props.points !== null"
                   :disabled="!$props.canActivate"
                   variant="primary"
                   size="small"
                   @click="activateBenefit">
        {{ $t('common.activate') }}
      </base-button>
      <base-button v-else-if="$props.totalPoints === undefined && !$props.points"
                   :disabled="$props.disabled"
                   variant="secondary"
                   size="small"
                   @click="openLearnMore">
        {{ $t('benefits.learnMore') }}
      </base-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'benefits-item',
  props: {
    totalPoints: {
      type: Number
    },
    points: {
      type: Number
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    canActivate: {
      type: Boolean
    },
    disabled: Boolean
  },
  computed: {
    pointsText () {
      const lastDigit = this.points % 10
      return this.points === 11 || lastDigit !== 1 ? this.$t('benefits.points') : this.$t('benefits.point')
    }
  },
  methods: {
    activateBenefit () {
      this.$emit('activate-benefit')
    },
    openLearnMore () {
      this.$emit('learn-more')
    }
  }
}
</script>
<style scoped lang="scss">
.benefits-item {
  border-radius: .5rem;
  margin-bottom: .8rem;
  background: $white;

  @media (map_get($breakpoints, sm)) {
    display: flex;
  }
}

.total-points {
  margin-left: 1rem;
  color: $primary;
  font-size: 2rem;

  @media (map_get($breakpoints, sm)) {
    font-size: 2.4rem;
  }
}

.benefits-points {
  display: flex;
  align-items: center;
  flex: 0 0 7.5rem;
  box-shadow: .3rem 0 1rem 0 rgba(0, 0, 0, .05);
  padding: .8rem 1.6rem;
  color: $primary;
  text-align: center;
  font-weight: 600;

  @media (map_get($breakpoints, sm)) {
    flex-direction: column;
    justify-content: center;
    padding: 0 1.6rem;
  }

  p {
    margin-right: .8rem;
    font-size: 2.4rem;

    @media (map_get($breakpoints, sm)) {
      margin-right: 0;
    }
  }
}

.benefits-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1.6rem;
  width: 100%;

  @media (map_get($breakpoints, sm)) {
    flex-direction: row;
    align-items: center;
    padding: 2.4rem;
  }

  .base-button {
    margin-top: 2.5rem;
    width: 100%;

    @media (map_get($breakpoints, sm)) {
      margin-top: 0;
      margin-left: 2rem;
      min-width: 14rem;
      width: auto;
    }
  }
}

.benefits-desc {
  display: flex;
  align-items: center;
  margin-right: auto;
  font-size: 1.4rem;
  font-weight: 600;

  @media (map_get($breakpoints, sm)) {
    font-size: 1.6rem;
  }
}

.benefits-desc-text {
  margin-top: .4rem;
  color: $dark-grey;
  font-size: 1.2rem;
  font-weight: 400;
}
</style>
